const BASE_URL = 'https://api.frankfurter.app';

const FALLBACK_CURRENCIES: Record<string, string> = {
  "USD": "United States Dollar",
  "EUR": "Euro",
  "GBP": "British Pound",
  "AUD": "Australian Dollar",
  "CAD": "Canadian Dollar",
  "CHF": "Swiss Franc",
  "JPY": "Japanese Yen",
  "CNY": "Chinese Yuan",
  "INR": "Indian Rupee",
  "BRL": "Brazilian Real",
  "SEK": "Swedish Krona",
  "NOK": "Norwegian Krone",
  "DKK": "Danish Krone",
  "PLN": "Polish Zloty",
  "NZD": "New Zealand Dollar",
  "HKD": "Hong Kong Dollar",
  "KRW": "South Korean Won",
  "MXN": "Mexican Peso",
  "SGD": "Singapore Dollar",
};

export const convertCurrency = async (amount: number, from: string, to: string, date?: string) => {
  if (from === to) return amount;
  
  const dateStr = date ?? 'latest';
  try {
    const response = await fetch(`${BASE_URL}/${dateStr}?amount=${amount}&from=${from}&to=${to}`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json() as { rates?: Record<string, number> };
    
    if (data.rates?.[to]) {
      return data.rates[to];
    }
    throw new Error("Conversion failed");
  } catch (error) {
    console.error("Currency conversion error:", error);
    return amount;
  }
};

export const getAvailableCurrencies = async (): Promise<Record<string, string>> => {
  try {
    const response = await fetch(`${BASE_URL}/currencies`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json() as Record<string, string>;
    return data;
  } catch (error) {
    console.error("Error fetching currencies:", error);
    return FALLBACK_CURRENCIES;
  }
};
